const toGameSlug = (title) => {
  if (!title || typeof title !== 'string') return '';
  return title
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
};

export const getGamePath = (game) => {
  if (!game) return '/all-games';

  const slug = game.slug || toGameSlug(game.title);
  if (slug) return `/game/${slug}`;

  const id = game.id || game._id;
  return id ? `/game/${id}` : '/all-games';
};
